import app from 'flarum/common/app';
import Hero from 'flarum/forum/components/Hero';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';

/**
 * The `PageHero` component displays the hero on a page page.
 *
 * ### Props
 *
 * - `page`
 */
export default class PageHero extends Hero {
  className() {
    return 'PageHero';
  }
  bodyItems() {
    const items = new ItemList();
    items.add('items', m("ul", {
      className: "PageHero-items"
    }, listItems(this.items().toArray())), 100);
    return items;
  }

  /**
   * Build an item list for the contents of the page hero.
   *
   * @return {ItemList}
   */
  items() {
    const items = new ItemList();
    const page = this.attrs.page;
    items.add('title', m("h1", {
      className: "PageHero-title"
    }, m(Link, {
      href: app.route.page(page)
    }, page.title())));
    return items;
  }
}
flarum.reg.add('fof-pages', 'forum/components/PageHero', PageHero);